import { Chip, Typography } from '@mui/material';
import { CardSection, CardSubSection } from '@side/pantry';
import { BuyerFormsGroup } from './BuyerDetailsSection/BuyerFormsGroup';
import { SellerAgentSection } from './SellerAgentSection';

export const UnrepresentedBuyerDetails = () => (
  <>
    <CardSection
      cardTitle="Buyer's Agent"
      action={
        <Chip label="Unrepresented Buyer" size="small" variant="outlined" />
      }
    >
      <CardSubSection>
        <Typography variant="body2" sx={{ color: 'text.secondary' }}>
          No agent will be assigned to this buyer and no buyer agreement is
          needed
        </Typography>
      </CardSubSection>
    </CardSection>
    <CardSection cardTitle="Buyer">
      <CardSubSection>
        <BuyerFormsGroup />
      </CardSubSection>
    </CardSection>
    <SellerAgentSection />
  </>
);
